// extracted by mini-css-extract-plugin
export default {"carousel":"BooksCarousel_carousel__Ug0x7","carouselItem":"BooksCarousel_carouselItem__9US0w"};